import React, {PureComponent, CSSProperties} from 'react'
import cxs from 'cxs/component'
import Theme from 'Theme'
import {Icon} from 'elements'

interface Props {
  checked?: boolean
  label?: string
  className?: string
  onChange(checked: boolean): void
}

class CheckBox extends PureComponent<Props, object> {
  render() {
    const {label, checked, onChange, ...props} = this.props
    return (
      <Label {...props} onClick={() => onChange(!checked)}>
        <Box>{checked ? <Icon style={{
          padding: 0,
        }}
        name="tick" /> : null}</Box>
        <Span style={{textTransform: 'unset'}}>{label}</Span>
      </Label>
    )
  }
}

export default CheckBox

const Label = cxs('label')({
  display: 'block',
  padding: Theme.size.space[1]
} as CSSProperties)

const Box = cxs('div')({
  display: 'inline-block',
  width: Theme.fontSize.big,
  height: Theme.fontSize.big,
  marginRight: Theme.size.space[1],
  verticalAlign: 'sub',
  border: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  '> icon': {
    padding: 0
  }
} as CSSProperties)

const Span = cxs('span')({
  display: 'inline-block'
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/CheckBox.tsx